<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="dialog-content">
    <h1 mat-dialog-title>{{ 'REPRESENTATIVE.DIALOG.SEND_EMAIL_HEADER' | translate }}</h1>
    <p>{{ 'REPRESENTATIVE.DIALOG.SEND_EMAIL_TEXT' | translate }}</p>
    <div class="form-field">
      <app-select class="input-field" [control]="form.controls['language']" [itemsSource]="languages"></app-select>
    </div>

    <div class="form-field">
      <app-email-box [control]="form.controls['email']"></app-email-box>
    </div>
  </div>

  <div class="button-container">
    <button class="btn btn-cancel" (click)="cancel()" type="button">{{ 'CANCEL_BTN' | translate }}</button>
    <button class="btn btn-custom" type="submit">
      <img src="assets/icons/telegram-icon.png" />
      {{ 'REPRESENTATIVE.DIALOG.SEND_EMAIL_BUTTON' | translate }}
    </button>
  </div>
</form>
